import styled from 'styled-components';
import { Chip } from '@material-ui/core';

export const FilterChip = styled(Chip)`
    font-size: 1rem;
`;